export const SIGN_IN_USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9_\-+.]{3,15}\s*$/;

export const USERNAME_FIRST_SYMBOL_REGEX = /^[a-zA-Z]/;

export const USERNAME_REGEX = /^[a-zA-Z][a-zA-Z\d_]{5,14}$/;

export const USERNAME_MINIMAL_LENGTH = 6;

export const FIRST_LAST_NAME_REGEX = /^[a-zA-Z][a-zA-Z0-9\-_]*$/;
